import { render, staticRenderFns } from "./CalendarContent.vue?vue&type=template&id=2371db30&scoped=true"
import script from "./CalendarContent.vue?vue&type=script&lang=js"
export * from "./CalendarContent.vue?vue&type=script&lang=js"
import style0 from "./CalendarContent.vue?vue&type=style&index=0&id=2371db30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2371db30",
  null
  
)

export default component.exports